var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useTheme } from "../hooks/useTheme";
import { LibIcon } from './components';
export var CsvBasic = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 25 : _b, _c = _a.lss, lss = _c === void 0 ? { color: 'primary500' } : _c, _d = _a.title, title = _d === void 0 ? '' : _d, props = __rest(_a, ["size", "lss", "title"]);
    var theme = useTheme();
    return (React.createElement("svg", __assign({ width: size, height: 1.25 * size, viewBox: "0 0 16 20" }, props),
        title && React.createElement("title", null, title),
        React.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { id: "8", transform: "translate(-41.000000, -300.000000)" },
                React.createElement("g", { id: "Group-4", transform: "translate(35.000000, 294.000000)" },
                    React.createElement("g", { id: "Group-26", transform: "translate(6.000000, 6.000000)" },
                        React.createElement("path", { d: "M9.5485159,0 L15.6521739,6.0963021 L15.6521739,20 L0,20 L0,0 L9.5485159,0 Z M9.56521739,1.30434783 L9.56521739,6.08695652 L14.3478261,6.08695652 L9.56521739,1.30434783 Z", id: "Combined-Shape", fill: theme.colors[lss.color] }),
                        React.createElement("text", { id: "CSV", fontFamily: "Helvetica", fontSize: "6", fontWeight: "bold", fill: theme.colors.white },
                            React.createElement("tspan", { x: "2.18956522", y: "13.3913043" }, "CSV"))))))));
};
export var CsvBasicIcon = function (props) { return (React.createElement(LibIcon, __assign({ icon: CsvBasic }, props))); };
//# sourceMappingURL=CsvBasicIcon.js.map